import LocationField from './location-field.js';

class PropertiesSearchForm {
    constructor(el) {
        this.el = el;

        if(this.el) {
            this._init();
        }
    }

    _init() {
        this.locationField = null;
        this.locationFieldEl = this.el.querySelector('.location-field');
        
        if(this.locationFieldEl) {
            this.locationField = new LocationField(this.locationFieldEl);
        }
        
        this._bindEvents();
    }

    _bindEvents() {
        this.onSubmitFn = this._onSubmit.bind(this);
        
        this.el.addEventListener('submit', this.onSubmitFn);
    }

    _onSubmit(e) {
        e.preventDefault();

        if(this.locationField && this.locationField.isValid()) {
            this.el.submit();
        }
    }
}

export default PropertiesSearchForm;

new PropertiesSearchForm(document.querySelector('.properties-search-form'));